<app-header class="layout-header"></app-header>

<js-thomas-dock class="layout-body">
  <dx-scroll-view class="layout-scroll with-footer">
    <div class="content">
      <ng-content></ng-content>
    </div>

    <div class="content-block">
      <ng-content select="app-footer"></ng-content>
    </div>
  </dx-scroll-view>
</js-thomas-dock>
